/**
 * This package is framework-free, so schemas here cannot reach the frontend's
 * i18next instance. Zod messages on shared schemas are therefore i18n *keys*,
 * and consumers translate `error.message` where they render it.
 */
export const ValidationMessageKey = {
  nonEmpty: "validation.mustContainAtLeastOneCharacter",
  maxLength100: "validation.mustContainAtMost100Characters",
} as const;
